// @ts-nocheck

import { externalLinkOpen } from '../actions/externallink';
import userActions from '../actions/user';
import { isIOSEmbeddedAndStandalone } from '../client';
import { Target } from '../client';
import config from '../config/app.config';
import { getRedirectUrl } from '../config/urls';
import { getLang } from '../i18n/l10n';
import { isEmbedded } from '../lib/useragent';
import { openGRView } from '../modules/gift-race/actions/routes';
import { isGridsAllowed } from '../modules/grids/utils';
import { openKLView } from '../modules/koh-lanta/actions/routes';
import { openMPView } from '../modules/monopoly/actions/routes';
import { NotificationRoutingBehaviors } from '../types/notifications';

import RoutesRedirectionFactory from './routes/RoutesRedirectionFactory';

import { getCurrentURIParams, parseUrl } from './index';

const baseURI = '/betting/redirect.php?';

const getRoutingFunc = (routingBehavior = NotificationRoutingBehaviors.REPLACE, history) => {
  if (routingBehavior === NotificationRoutingBehaviors.PUSH) {
    return history.push;
  }
  // Par defaut, on fait un replace
  return history.replace;
};

const openLinkFromDeeplink = (dispatch, url, options, withDelay = true) => {
  setTimeout(
    () => {
      dispatch(externalLinkOpen(url, options));
    },
    withDelay ? 2000 : 0,
  );
};

const handleTarget = (options) => {
  const { target, lang, parsedURI, history, dispatch, routingBehavior } = options;
  const routingFunc = getRoutingFunc(routingBehavior, history);

  if (target === 'live') {
    // wam://betting?target=live
    handleTargetAsLive({ routingFunc });
  } else if (target === 'history') {
    // wam://betting?target=history
    handleTargetAsHistory({ routingFunc });
  } else if (/^catalog-([0-9]+)(-([0-9]+))?(-([0-9]+))?$/i.test(target)) {
    // wam://betting?target=catalog-2736-27172-18373
    const matches = target?.match(/^catalog-([0-9]+)(-([0-9]+))?(-([0-9]+))?$/i);
    handleTargetAsCatalog({ matches, routingFunc });
  } else if (/^history-([A-Z0-9]{5}-[A-Z0-9]{8}(-[0-9]+)?$)/i.test(target)) {
    // wam://betting?target=history-ZEF23-2HUIKUHF-32
    const matches = target?.match(/^history-([A-Z0-9]{5}-[A-Z0-9]{8}(-[0-9]+)?$)/i);
    handleTargetAsHistoryById({ matches, routingFunc });
  } else if (/^match-([0-9]+)$/.test(target)) {
    // wam://betting?target=match-327234987&lineup=1
    // wam://betting?target=match-327234987&highlightId=PERFORM:1234
    const matches = target?.match(/^match-([0-9]+)$/);
    handleTargetAsMatch({ matches, parsedURI, routingFunc });
  } else if (target === 'extras') {
    handleTargetAsExtras({ parsedURI, routingFunc });
  } else if (target === 'fantasy') {
    // wam://betting?target=fantasy
    // wam://betting?target=fantasy&contestId=23423872
    handleTargetAsFantasy(options);
  } else if (target === 'fantasy-upcoming') {
    // wam://betting?target=fantasy-upcoming
    handleTargetAsFantasyUpcoming(options);
  } else if (target === 'fantasy-finished') {
    // wam://betting?target=fantasy-finished
    handleTargetAsFantasyFinished(options);
  } else if (target === 'grids') {
    // wam://betting?target=grids
    // wam://betting?target=grids&betslipId=277EHE-294R23H
    if (isGridsAllowed(lang)) {
      handleTargetAsGrids({ parsedURI, routingFunc });
    }
  } else if (target === 'grids-history') {
    // wam://betting?target=grids-history
    if (isGridsAllowed(lang)) {
      handleTargetAsGridsHistory({ routingFunc });
    }
  } else if (target === 'kl') {
    handleTargetAsKL({ dispatch });
  } else if (target === 'gr') {
    handleTargetsGiftRace({ dispatch });
  } else if (target === 'monopoly') {
    // wam://betting?target=monopoly
    handleTargetAsMonopoly({ dispatch });
  } else if (target === 'boom') {
    // wam://betting?target=boom
    handleTargetAsBoom({ routingFunc });
  } else if (target === 'redirect') {
    // wam://betting?target=redirect&service=xxx&auth=true
    handleTargetAsRedirect(options);
  } else if (target === 'graphics-preferences') {
    // wam://betting?target=graphics-preferences
    handleTargetAsGraphicsPreferences({ routingFunc });
  } else if (target === 'betshare') {
    // wam://betting?target=betshare&shortURLId=123&ref=ABC123
    handleTargetAsBetshare({ parsedURI, routingFunc });
  } else {
    if (Target.__ENV__ !== 'production') {
      console.error('Unrecognized notification target', target);
      throw new Error('Unhandled notification target');
    }
  }
};

const handleTargetAsKL = ({ dispatch }) => {
  dispatch(openKLView());
};

const handleTargetsGiftRace = ({ dispatch }) => {
  dispatch(openGRView());
};

const handleTargetAsMonopoly = ({ dispatch }) => {
  dispatch(openMPView());
};

const handleTargetAsBoom = ({ routingFunc }) => {
  routingFunc(RoutesRedirectionFactory.getBoomRouteConfig());
};

const handleTargetAsLive = ({ routingFunc }) => {
  routingFunc(RoutesRedirectionFactory.getLiveRouteConfig());
};

const handleTargetAsHistory = ({ routingFunc }) => {
  routingFunc(RoutesRedirectionFactory.getHistoryRouteConfig());
};

const handleTargetAsCatalog = ({ matches, routingFunc }) => {
  if (matches && Array.isArray(matches) && matches.length > 1) {
    let url = `/sports/${matches[1]}`;

    // Si on a une categorie
    if (matches[3]) {
      url += `/${matches[3]}`;
    }

    // Si on a un tournoi
    if (matches[5]) {
      url += `/${matches[5]}`;
    }

    routingFunc(url);
  }
};

const handleTargetAsHistoryById = ({ matches, routingFunc }) => {
  if (matches && Array.isArray(matches) && matches.length > 1) {
    routingFunc(RoutesRedirectionFactory.getHistoryBetslipDetailsRouteConfig(matches[1]));
  }
};

const handleTargetAsMatch = ({ matches, parsedURI, routingFunc }) => {
  if (matches && Array.isArray(matches) && matches.length > 1) {
    const matchId = parseInt(matches[1], 10);

    if (matchId && !isNaN(matchId)) {
      const { highlightId, lineup } = parsedURI;

      if (lineup) {
        routingFunc(RoutesRedirectionFactory.getLineUpRouteConfig(matchId));
      } else if (highlightId) {
        routingFunc(RoutesRedirectionFactory.getMatchHighlightRouteConfig(matchId, highlightId));
      } else {
        routingFunc(RoutesRedirectionFactory.getMatchRouteConfig(matchId));
      }
    }
  }
};

const handleTargetAsExtras = ({ parsedURI, routingFunc }) => {
  const { missionId: missionIdAsStr } = parsedURI;
  const missionId = parseInt(missionIdAsStr, 10);

  if (!isNaN(missionId) && typeof missionId === 'number') {
    routingFunc(RoutesRedirectionFactory.getMissionsDetailsRouteConfig(missionId));
  } else {
    routingFunc(RoutesRedirectionFactory.getExtrasRouteConfig());
  }
};

const handleTargetAsFantasy = (options) => {
  const { lang, parsedURI, dispatch, internalNavigation } = options;
  const { contestId } = parsedURI;
  if (!isNaN(contestId)) {
    openLinkFromDeeplink(
      dispatch,
      `${config.webHost[lang]}${baseURI}service=fantasy&contestId=${contestId}`,
      { auth: true },
      !internalNavigation,
    );
  } else {
    openLinkFromDeeplink(
      dispatch,
      `${config.webHost[lang]}${baseURI}service=fantasy`,
      { auth: true },
      !internalNavigation,
    );
  }
};

const handleTargetAsFantasyUpcoming = (options) => {
  const { lang, dispatch, internalNavigation } = options;
  openLinkFromDeeplink(
    dispatch,
    `${config.webHost[lang]}${baseURI}service=fantasy-upcoming`,
    { auth: true },
    !internalNavigation,
  );
};

const handleTargetAsFantasyFinished = (options) => {
  const { lang, dispatch, internalNavigation } = options;
  openLinkFromDeeplink(
    dispatch,
    `${config.webHost[lang]}${baseURI}service=fantasy-finished`,
    { auth: true },
    !internalNavigation,
  );
};

const handleTargetAsGrids = ({ parsedURI, routingFunc }) => {
  const { betslipId } = parsedURI;

  if (betslipId) {
    routingFunc(RoutesRedirectionFactory.getGridsGridShareRouteConfig(betslipId));
  } else {
    routingFunc(RoutesRedirectionFactory.getGridsRouteConfig());
  }
};

const handleTargetAsGridsHistory = ({ routingFunc }) => {
  routingFunc(RoutesRedirectionFactory.getGridsHistoryRouteConfig());
};

const handleTargetAsGraphicsPreferences = ({ routingFunc }) => {
  routingFunc(RoutesRedirectionFactory.getGraphicsPreferencesRouteConfig());
};

const handleTargetAsBetshare = ({ parsedURI, routingFunc }) => {
  const { shortURLId, ref } = parsedURI;

  routingFunc(RoutesRedirectionFactory.getBetshareRouteConfig(shortURLId, ref));
};

const handleTargetAsRedirect = ({ parsedURI, dispatch, internalNavigation }) => {
  const { s, auth, external } = parsedURI;
  openLinkFromDeeplink(
    dispatch,
    getRedirectUrl(s),
    {
      auth: !!auth,
      external: !!external,
    },
    !internalNavigation,
  );
};

const handleEmbeddedNotification = (history, dispatch) => {
  if (isEmbedded) {
    const parsedURI = getCurrentURIParams();
    const { target } = parsedURI || {};

    if (target && target !== '') {
      // Handle target url (only iOS embed & standalone)
      if (isIOSEmbeddedAndStandalone) {
        const lang = getLang();
        handleTarget({
          target,
          lang,
          parsedURI,
          history,
          dispatch,
          routingBehavior: NotificationRoutingBehaviors.REPLACE,
        });
      }
      dispatch(userActions.setEmbeddedNotificationTarget(target));
    }
  }
};

export const handleInternalNavigation = ({
  history,
  dispatch,
  uri,
  routingBehavior = NotificationRoutingBehaviors.PUSH,
}) => {
  const {
    url,
    query: { target, ...query },
  } = parseUrl(uri);

  if (url === 'wam://betting') {
    if (target) {
      handleTarget({
        target,
        lang: getLang(),
        parsedURI: query,
        history,
        dispatch,
        routingBehavior,
        internalNavigation: true,
      });
    } else {
      history.replace(RoutesRedirectionFactory.getHomeRouteConfig());
    }
  }
};

export default handleEmbeddedNotification;
